import { useQuery } from '@tanstack/react-query';
import service from '../service';
import type { CustomFormData } from '@Components/DynamicCustomForm/types';
import type { CustomFormListItem } from '@Types/customForm';

/** Every live custom form. */
export const CUSTOM_FORMS_QUERY_KEY = ['customForms'];

/** One form by id; `StageConditionsEditor` reads the same key. */
export const customFormQueryKey = (id: string | undefined) => ['customForm', id];

export function useCustomForms() {
  return useQuery({
    queryKey: CUSTOM_FORMS_QUERY_KEY,
    queryFn: async (): Promise<CustomFormListItem[]> => {
      const res = await service.getAllCustomForms();
      if (!res.ok) throw new Error('Custom forms could not be loaded');
      return res.json();
    },
  });
}

export function useCustomForm(id: string | undefined) {
  return useQuery({
    queryKey: customFormQueryKey(id),
    enabled: !!id,
    queryFn: async (): Promise<CustomFormData> => {
      const res = await service.getCustomFormById(id as string);
      if (!res.ok) throw new Error('Custom form could not be loaded');
      return res.json();
    },
  });
}
